import { createVanIconComponent } from "./van"

const SmileCommentOutlined = createVanIconComponent("smile-comment-o")
export default SmileCommentOutlined
